import { render, staticRenderFns } from "./SpyderEmptyState.vue?vue&type=template&id=ffca6058&scoped=true"
import script from "./SpyderEmptyState.vue?vue&type=script&lang=js"
export * from "./SpyderEmptyState.vue?vue&type=script&lang=js"
import style0 from "./SpyderEmptyState.vue?vue&type=style&index=0&id=ffca6058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffca6058",
  null
  
)

export default component.exports